import RelativeImage from './RelativeImage'

export default RelativeImage
